import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-people-gender-panel',
    templateUrl: './people-gender-panel.component.html',
    styleUrls: ['./people-gender-panel.component.scss'],
    standalone: false
})
export class PeopleGenderPanelComponent {
    @Input() public formGroup: FormGroup;
    @Input() public peopleGenderControlName: string = 'peopleGender';
    @Input() public isGenderTotalInvalid: boolean = false;

    public get genderGroup(): FormGroup {
        return (this.formGroup?.get(this.peopleGenderControlName) as FormGroup) ?? null;
    }

    public get total(): number | string {
        const group = this.genderGroup;
        if (!group) {
            return '';
        }
        const fields = [
            group.get('women')?.value,
            group.get('men')?.value,
            group.get('nonBinary')?.value,
            group.get('preferNotToSay')?.value
        ];
        const hasValues = fields.some(val => val !== null && val !== undefined && (val as any) !== '');
        if (!hasValues) {
            return '';
        }
        const sum = fields.reduce((acc: number, val) => {
            const hasValue = val !== null && val !== undefined && (val as any) !== '';
            return acc + (hasValue ? Number(val) : 0);
        }, 0);
        return parseFloat(sum.toFixed(4));
    }

    public get hasValues(): boolean {
        const group = this.genderGroup;
        if (!group) {
            return false;
        }
        const fields = [
            group.get('women')?.value,
            group.get('men')?.value,
            group.get('nonBinary')?.value,
            group.get('preferNotToSay')?.value
        ];
        return fields.some(val => val !== null && val !== undefined && (val as any) !== '');
    }

    public clear(): void {
        const group = this.genderGroup;
        if (group) {
            group.patchValue({
                women: null,
                men: null,
                nonBinary: null,
                preferNotToSay: null
            });
            group.markAsDirty();
            this.formGroup?.markAsDirty();
        }
    }

    public preventScientificNotation(event: KeyboardEvent): void {
        if (['e', 'E'].includes(event.key)) {
            event.preventDefault();
        }
    }

    public preventNonNumericPaste(event: ClipboardEvent): void {
        const clipboardData = event.clipboardData?.getData('text');
        if (clipboardData) {
            const num = Number(clipboardData.trim());
            if (isNaN(num)) {
                event.preventDefault();
            }
        }
    }
}

